import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { ecNoOnlyWhiteSpacesValidator } from '@cf/core';
import {
  BookingPageQuestionsAnswerTypeEnum,
  SchemaMeetingTemplateQuestion,
} from '@cf/temp/services';
import { IBookingQuestionFormDto, IBookingQuestionFormGroup } from '../interfaces';

export const OTHER_ANSWER_ID = 0;

export const prepareBookingQuestionsDto = (
  questionsForm: FormArray<FormGroup<IBookingQuestionFormGroup>>,
) => {
  return structuredClone(questionsForm.value)
    .map((question) => {
      question.answer_text = question.answer_text?.trim();

      if (question.answer !== undefined && question.answer !== null) {
        question.answers = [question.answer];
      }

      if (question.answers?.includes(OTHER_ANSWER_ID)) {
        question.is_other_option = true;
        question.answers = question.answers?.filter((question) => question !== OTHER_ANSWER_ID);
      }

      delete question.answer;
      return question;
    })
    .filter((question) => question.answers?.length || question.answer_text);
};

export const getAnswerTextFieldValidators = (question: SchemaMeetingTemplateQuestion) => {
  const baseValidation = [Validators.maxLength(1000), ecNoOnlyWhiteSpacesValidator];
  const initialTextFields: SchemaMeetingTemplateQuestion['answer_type'][] = [
    BookingPageQuestionsAnswerTypeEnum.shortText,
    BookingPageQuestionsAnswerTypeEnum.longText,
    BookingPageQuestionsAnswerTypeEnum.phoneNumber,
  ];

  if (question.required && initialTextFields.includes(question.answer_type)) {
    return [Validators.required, ...baseValidation];
  }

  return baseValidation;
};

export const getAnswerFieldValidators = (question: SchemaMeetingTemplateQuestion) => {
  if (
    question.required &&
    (question.answer_type === BookingPageQuestionsAnswerTypeEnum.dropdown ||
      question.answer_type === BookingPageQuestionsAnswerTypeEnum.radioButtons)
  ) {
    return [Validators.required];
  }

  return;
};

export const getAnswersFieldValidators = (question: SchemaMeetingTemplateQuestion) => {
  if (question.required && question.answer_type === BookingPageQuestionsAnswerTypeEnum.checkboxes) {
    return [Validators.required];
  }

  return;
};

export const setBookingQuestionFormErrors = (
  form: FormGroup,
  error: HttpErrorResponse,
  questionsDto: IBookingQuestionFormDto[],
): void => {
  const questionsErrors = error.error?.errors?.questions;
  const questionsFormArray = form.controls['questions'];

  if (!questionsErrors || !questionsFormArray || !questionsDto) {
    return; // Exit if any required input is missing
  }

  // Iterate over the errors and apply them to the corresponding form controls
  questionsErrors.forEach((errorItem: any, index: number) => {
    if (!Array.isArray(errorItem) || errorItem.length === 0) {
      return; // Skip if there are no errors for this question
    }

    const questionId = questionsDto[index]?.question;
    if (!questionId) {
      return; // Skip if the question ID is invalid
    }

    // Find the corresponding form control for the question
    const questionIndex = questionsFormArray.value.findIndex(
      (question: IBookingQuestionFormDto) => question.question === questionId,
    );

    if (questionIndex === -1) {
      return; // Skip if no matching question is found in the form
    }

    // Access the form control for the question and set the error
    const questionControl = (questionsFormArray as any).controls[questionIndex];
    if (questionControl?.controls?.answer_text) {
      const errorMessage = errorItem[0]?.answer_text?.[0]?.message;
      questionControl.controls.answer_text.setErrors({ custom: errorMessage });
    }
  });
};
